import { request } from "@/utils/request";

/**
 * 分页查询 NVOCC 备案列表
 * @param {Object} params
 * @param {string} [params.keyword] 企业名称
 * @param {string} [params.region] 地区
 * @param {string} [params.filingType] 备案类型
 * @param {number} [params.pageNo]
 * @param {number} [params.pageSize]
 */
export function getNvoccPage(params) {
    return request("/nvocc/page", "post", params);
}

/**
 * 备案详情
 * @param {number|string} id
 */
export function getNvoccDetail(id) {
    return request(`/nvocc/detail/${id}`, "get");
}

/**
 * 地域分布统计
 */
export function getNvoccStats() {
    return request("/nvocc/stats", "get");
}

/**
 * 筛选项
 */
export function getNvoccFilters() {
    return request("/nvocc/filters", "get");
}

/**
 * 查看联系方式（仅企业用户）
 * @param {number|string} id
 */
export function getNvoccContact(id) {
    return request(`/nvocc/contact/${id}`, "get");
}
